import ConnectedNPS from './ConnectedNPS';
import NPS from './NPS';

export const UnconnectedNPS = NPS;
export default ConnectedNPS;
